import * as Yup from "yup";

const itemSchema = {};

itemSchema.validateItemAdd = () => {
  return Yup.object({
    item_name: Yup.string()
      .trim()
      .required(" Name is required.")
      .min(3, " Name minimum length is 3")
      .max(100, " Name should be at most 100 characters."),
    video_url: Yup.string()
      .trim()
      .nullable()
      .notRequired()
      .test("is-valid-url", "Invalid video URL", function (value) {
        if (!value) return true;
        return Yup.string().url().isValidSync(value);
      }),
    item_price: Yup.string()
      .required(" Price is required.")
      .matches(/^[\.0-9\s]+$/, ` Price should be Number`),
    alt_price: Yup.string()
      .required("Alternate Price is required.")
      .matches(/^[\.0-9\s]+$/, `Alternate Price should be Number`),
    item_unit: Yup.string().required("Base Unit is required."),
    // .matches(/^[aA-z0-9Z-\s]+$/, `Base Unit should be Varchar`),

    alt_unit: Yup.string().required("Alternate Unit is required."),
    // .matches(/^[aA-z0-9Z-\s]+$/, `Alternate Unit should be Varchar`),

    alt_conv: Yup.string()
      .required("Alternate Conversion is required.")
      .test(
        "is-greater-than-0",
        "Alternate Conversion should be greater than 0",
        (value) => parseFloat(value) > 0,
      ),
    item_min_price: Yup.string()
      .matches(/^[\.0-9\s]+$/, `Min Price should be Number`)
      .test(
        "is-less-than-or-equal-to-max",
        "Min Price should be less than or equal to Max Price",
        function (value) {
          const maxPrice = this.parent.item_price;
          if (!value || value.trim() === "") {
            return true;
          }
          const minNum = parseFloat(value);
          const maxNum = parseFloat(maxPrice);
          return !isNaN(minNum) && !isNaN(maxNum) && minNum <= maxNum;
        },
      ),
    alt_min_price: Yup.string()
      .matches(/^[\.0-9\s]+$/, `Min Alternate Price should be Number`)
      .test(
        "is-less-than-or-equal-to-alt-max",
        "Min Alternate Price should be less than or equal to Max Alternate Price",
        function (value) {
          const altMaxPrice = this.parent.alt_price;
          if (!value || value.trim() === "") {
            return true; // Optional: allow empty
          }
          const minNum = parseFloat(value);
          const maxNum = parseFloat(altMaxPrice);
          return !isNaN(minNum) && !isNaN(maxNum) && minNum <= maxNum;
        },
      ),
    category_code: Yup.string()
      .trim()
      .nullable()
      .notRequired()
      .test(
        "category-code-test",
        "Category Code must be an 8-digit number.",
        (value) => {
          if (!value || value.trim() === "") return true;
          return /^\d{8}$/.test(value.trim());
        },
      ),
  });
};
// @#$&*(){}[]:',.|
itemSchema.validateItemEdit = () => {
  return Yup.object({
    item_name: Yup.string()
      .trim()
      .required(" Name is required.")
      .min(3, " Name minimum length is 3")
      .max(100, " Name should be at most 100 characters."),

    video_URL: Yup.string()
      .trim()
      .nullable()
      .notRequired()
      .test("is-valid-url", "Invalid video URL", function (value) {
        if (!value) return true;
        return Yup.string().url().isValidSync(value);
      }),
    item_price: Yup.string()
      .required(" Price is required.")
      .matches(/^[\.0-9\s]+$/, ` Price should be Number`)
      .nullable(),
    alt_price: Yup.string()
      .required("Alternate Price is required.")
      .matches(/^[\.0-9\s]+$/, `Alternate Price should be Number`)
      .nullable(),
    item_unit: Yup.string()
      .required("Base Unit is required.")
      // .matches(/^[aA-z0-9Z-\s]+$/, `Base Unit should be Varchar`)
      .nullable(),
    alt_unit: Yup.string()
      .required("Alternate Unit is required.")
      // .matches(/^[aA-z0-9Z-\s]+$/, `Alternate Unit should be Varchar`)
      .nullable(),
    alt_conv: Yup.string()
      .required("Alternate Conversion is required.")
      .nullable()
      .test(
        "is-greater-than-0",
        "Alternate Conversion should be greater than 0",
        (value) => parseFloat(value) > 0,
      ),
    item_min_price: Yup.string()
      .matches(/^[\.0-9\s]+$/, `Min Price should be Number`)
      .test(
        "is-less-than-or-equal-to-max",
        "Min Price should be less than or equal to Max Price",
        function (value) {
          const maxPrice = this.parent.item_price;
          if (!value || value.trim() === "") {
            return true; // Optional: allow empty
          }
          const minNum = parseFloat(value);
          const maxNum = parseFloat(maxPrice);
          return !isNaN(minNum) && !isNaN(maxNum) && minNum <= maxNum;
        },
      )
      .nullable(),
    alt_min_price: Yup.string()
      .matches(/^[\.0-9\s]+$/, `Min Alternate Price should be Number`)
      .test(
        "is-less-than-or-equal-to-alt-max",
        "Min Alternate Price should be less than or equal to Max Alternate Price",
        function (value) {
          const altMaxPrice = this.parent.alt_price;
          if (!value || value.trim() === "") {
            return true; // Optional: allow empty
          }
          const minNum = parseFloat(value);
          const maxNum = parseFloat(altMaxPrice);
          return !isNaN(minNum) && !isNaN(maxNum) && minNum <= maxNum;
        },
      )
      .nullable(),
    category_code: Yup.string()
      .trim()
      .nullable()
      .notRequired()
      .test(
        "category-code-test",
        "Category Code must be an 8-digit number.",
        (value) => {
          if (!value || value.trim() === "") return true;
          return /^\d{8}$/.test(value.trim());
        },
      ),
  });
};

export default itemSchema;
